import './TopSources.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TopSourcesProps {
  topSources: any[] | null;
}

const TopSources: React.FC<TopSourcesProps> = ({ topSources }) => {
  const { t } = useTranslation();

  if (topSources?.length === 0) {
    return <></>;
  }

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">{t('insightPage.topSources')}</div>
      </div>
      <div className="stats-box ">
        <div className="stats-box__content"></div>
      </div>
    </div>
  );
};

export default TopSources;
